import {Customization} from '@eduvision/toolkit';
import {default as CustomLoginView} from '../views/LoginView';

export const LoginView: Customization['LoginView'] = {
  component: CustomLoginView
};